//import AuthService from '../services/auth.service';
class StrapiService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }
  async getChallenges(app_id, token) {
    try {
      return await fetch(`${this.baseUrl}?` + new URLSearchParams({
        key: app_id,
        geolocation_null: `${true}`
      }), {
        method: 'GET',
        //body: JSON.stringify(data),
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        }
      }).then((response) => response.json())
        .then(response => {
        //console.log("response",response);
        return response.data;
      });
    }
    catch (err) {
      console.log("error peticion:", err);
    }
  }
  async getChallengeId(id, app_id, token) {
    try {
      return await fetch(`${this.baseUrl}/${id}?` + new URLSearchParams({
        key: app_id
      }), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        }
      }).then((response) => response.json())
        .then(response => { console.log("response", response); return response.data; });
    }
    catch (err) {
      console.log("error peticion:", err);
    }
  }
  async getGeoChallenges(app_id, token, geoNear) {
    try {
      return await fetch(`${this.baseUrl}?` + new URLSearchParams({
        key: app_id,
        geoNear: geoNear
      }), {
        method: 'GET',
        //body: JSON.stringify(data),
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        }
      }).then((response) => response.json())
        .then(response => {
        console.log("response getGeoChallenges", response);
        return response.data;
      });
    }
    catch (err) {
      console.log("error peticion getGeoChallenges :", err);
    }
  }
}

export { StrapiService as S };
